<template>
  <div class="image-upload-box">
    <div class="btn-upload">
      <div>
        <v-btn color="info" :loading="isLoading || isUploading" :disabled="isView || isLoading || isUploading"
          @click="document.getElementById(`uploader-in-image-gallery-${refName}`).click()">
          <v-icon>{{ buttonIcon }}</v-icon>
          <span>{{ internalButtonText }}</span>
          <v-file-input :disabled="isView || isLoading || isUploading" @change="uploadImage" :ref="`${refName}`"
            :accept="accept" :multiple="multiple" hide-input prepend-icon=""
            :id="`uploader-in-image-gallery-${refName}`"></v-file-input>
        </v-btn>
        <div class="note" v-if="value && value.length">{{ $t('upload.file_count', { count: value.length }) }}...</div>
      </div>
      <v-btn color="error" outlined @click="removeFiles" v-if="value && value.length"
        :disabled="isView || isLoading || isUploading">
        <v-icon>mdi-close-circle-multiple-outline</v-icon>
        <span>{{ $t('delete_all') }}</span>
      </v-btn>
    </div>
    <div class="images-box" v-if="value && value.length">
      <v-overlay v-if="isLoading || isUploading" color="white" absolute opacity="0.6">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-overlay>
      <div :class="`image-item ${!file.isImage ? 'file-item' : ''}`" v-for="(file, index) in value"
        :key="`image-gallery-${index}`">
        <div v-if="!file.isImage" class="file-item-in">
          <v-icon>mdi-file-cloud</v-icon>
          <a :href="file.url" target="_blank" v-if="isView">{{ file.name }}</a>
          <div v-else> {{ file.name }} </div>
        </div>
        <div v-else class="image-item-in">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img v-bind="attrs" v-on="on" :src="file.url" :alt="`image-gallery-${index}-alt`"
                @error="imageError($event, index)">
            </template>
            <div>{{ file.name }}</div>
          </v-tooltip>
          <div> {{ file.name }} </div>
        </div>
        <v-btn class="bg-white" color="error" elevation="2" icon rounded small :disabled="isView"
          @click="removeFile(index)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { FileUpload } from "../classes";
export default {
  name: "ImagesGallery",
  data() {
    return {
      document,
      images: [],
      isUploading: false,
      imageFileLabel: ['png', 'jpg', 'gif', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'svg', 'avif', 'webp'],
      internalButtonText: ''
    };
  },
  props: {
    value: Array,
    isLoading: {
      type: Boolean,
      default: false
    },
    refName: {
      type: String,
      default: 'fileupload'
    },
    isView: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: 'image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: ''
    },
    buttonIcon: {
      type: String,
      default: 'mdi-cloud-upload'
    }
  },
  created() {
    this.internalButtonText = this.buttonText || this.$t('upload.upload_image_document')
  },
  methods: {
    async uploadImage(event) {
      if (!event) return;
      if (this.multiple) this.$emit("uploadImages", event);
      else {
        this.isUploading = true;
        try {
          const splitFileData = event.name ? event.name.split(".") : null;
          let fileLastName = splitFileData ? splitFileData[splitFileData.length - 1] || splitFileData[0] : null
          let file = await FileUpload.upload(event);
          file.name = event.name
          file.fileLastName = fileLastName
          file.isImage = this.imageFileLabel.includes(fileLastName) ? true : false
          if (!this.value) this.value = []
          this.value.push(file);
          this.isUploading = false;
        } catch (err) {
          this.isUploading = false;
          this.$toast.show({
            content: this.$t('error'),
            color: "error"
          });
        }
      }
    },
    removeFile(index) {
      if (index < 0) return;
      if (this.multiple) { }
      else {
        if (this.value && this.value.length) {
          this.value.splice(index, 1);
        }
      }
    },
    removeFiles() {
      this.$emit("input", []);
    },
    imageError(event, index) {
      if (index < 0) return;
      if (this.value && this.value.length && this.value[index]) {
        this.value[index].isImageError = true
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$size_min : 250px;
$color_bg_image_box: rgba(223, 223, 223, 0.5);

.image-upload-box {
  display: block;
  margin: 0;
  border: 1px solid $color_bg_image_box;
  border-radius: 5px;

  .btn-upload {
    margin: 10px 15px;
    padding-bottom: 5px;
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: baseline;

    .v-icon {
      margin-right: 5px;
    }

    .note {
      color: gray;
    }

    div {
      display: flex;
      gap: 20px;
      justify-content: flex-start;
      align-items: center;
    }

  }

  .images-box {
    position: relative;
    margin: 10px 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;

    .image-item {
      position: relative;
      // flex-basis: $size_min;
      background: $color_bg_image_box;
      border-radius: 5px;
      height: $size_min;
      min-width: $size_min;
      width: auto;

      .image-item-in {
        position: relative;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        transition: all 0.3s;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          border-radius: 5px;
        }

        div {
          position: absolute;
          bottom: 10px;
          margin: 0 5px;
          padding: 5px;
          border-radius: 5px;
          width: $size_min;
          text-align: center;
          background: rgba(255, 255, 255, 0.7);
          white-space: wrap;
        }
      }

      .image-item-in:hover {
        div {
          display: none;
        }
      }


      .v-btn {
        position: absolute;
        right: 10px;
        top: 10px;
      }

      .v-btn:hover {
        transform: scale(1.5);
      }
    }

    .file-item {
      display: flex;
      align-items: center;
      // height: 100px;

      .file-item-in {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        width: 100%;
        max-width: $size_min;

        .v-icon {
          font-size: 50px;
          width: 100%;
        }

        div,
        a {
          max-width: 90%;
          margin: 0 5px;
          padding: 5px;
          border-radius: 5px;
          text-align: center;
          background: rgba(255, 255, 255, 0.5);
          white-space: wrap;
        }

      }
    }
  }
}
</style>
